import styled from 'styled-components';

export const StyledAdminGroupsSelect = styled.div`
  position: relative;
  z-index: 1;

  width: 24.7rem;
  flex-shrink: 0;

  .selected-group {
    border: 1px solid
      ${(props) => (props.theme.id === 'dark' ? props.theme.accent2 : props.theme.accent3)};
    background-color: ${(props) => (props.theme.id === 'dark' ? props.theme.bg3 : props.theme.bg2)};

    height: 100%;
    width: 100%;

    border-radius: 5px;
    padding: 1.6rem;
    padding-right: 3.2rem;

    cursor: pointer;

    position: relative;
    z-index: 1;
    font-size: 1.8rem;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;

    &-name {
      max-height: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    @media screen and (max-width: 768px) {
      height: 3.7rem;
      padding: 1.1rem;
      font-size: 1.2rem;
    }

    @media (min-width: 768px) and (max-width: 1000px) {
      height: 4.2rem;
      padding: 1.2rem;
      font-size: 1.4rem;
    }

    @media (min-width: 1000px) and (max-width: 1400px) {
      height: 100%;
      padding: 1rem;
      font-size: 1.4rem;
    }
  }
  .drop-down-arrow {
    position: absolute;
    right: 1.5rem;
    top: 0;
    width: 1.7rem;
    height: 100%;
    transition: all 0.2s;

    > * {
      position: absolute;
      top: 50%;
      transform: translateY(-50%) rotate(180deg);
      width: 100%;
      height: 100%;
      fill: currentColor;
    }
    transform: scaleX(1) scaleY(1);

    &.collapsed {
      transform: scaleY(-1) scaleX(-1);
    }
  }
`;
